import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton, SpecraLink, SpecraSpinner, SpecraText } from '@mono/ui-components/ensigns';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../lib/renderRouterLink';
import { registryHref } from '../registryHref';
import { HOME_LABEL } from './DocumentPickerField';
import { RecordDocumentLinkButton } from './RecordDocumentLinkButton';
import { RecordDocumentUnlinkButton } from './RecordDocumentUnlinkButton';
/** One rail row: title (linked to its home when it has one), home label, Unlink when allowed. */ export function recordDocumentRow(entity, d) {
    return {
        id: d.key,
        label: /*#__PURE__*/ _jsx("span", {
            "data-testid": Testids.registryDocuments.row,
            children: d.href ? /*#__PURE__*/ _jsx(SpecraLink, {
                href: d.href,
                renderLink: renderRouterLink,
                children: d.title
            }) : d.title
        }),
        value: /*#__PURE__*/ _jsxs("span", {
            className: "inline-flex items-center gap-[var(--space-1)]",
            children: [
                d.homeLabel,
                d.unlinkable && /*#__PURE__*/ _jsx(RecordDocumentUnlinkButton, {
                    entity: entity,
                    artifactId: d.artifactId,
                    title: d.title
                })
            ]
        })
    };
}
/** The Documents section every record rail shares. `state` replaces the empty text (loading/error). */ export function recordDocumentsSection(entity, rows, canLink, state, emptyText = 'No documents linked yet.') {
    return {
        id: 'documents',
        title: 'Documents',
        action: /*#__PURE__*/ _jsx(RecordDocumentLinkButton, {
            entity: entity,
            canLink: canLink
        }),
        rows,
        children: state ?? (rows?.length ? undefined : /*#__PURE__*/ _jsx(SpecraText, {
            as: "p",
            size: "meta",
            tone: "muted",
            children: emptyText
        }))
    };
}
/** Section over a raw ListEntityDocuments response (gov org, vehicle, anchor). */ export function documentsSectionFromResponse(entity, docs, state) {
    const rows = (docs?.documents ?? []).map((d, i)=>recordDocumentRow(entity, {
            key: `${d.artifactId}-${i}`,
            artifactId: d.artifactId,
            title: d.title,
            href: d.homeRef ? registryHref(d.homeRef) : null,
            homeLabel: d.homeRef?.name || HOME_LABEL[d.home] || d.home,
            unlinkable: d.unlinkable
        }));
    return recordDocumentsSection(entity, rows, docs?.canLink ?? false, state);
}
/** Loading / retry affordance for a Documents query; undefined once it has data. */ export function documentsQueryState(q) {
    if (q.isError) return /*#__PURE__*/ _jsx(SpecraButton, {
        variant: "ghost",
        onClick: ()=>void q.refetch(),
        children: "Retry loading documents"
    });
    return q.isPending ? /*#__PURE__*/ _jsx(SpecraSpinner, {
        label: "Loading documents"
    }) : undefined;
}
